import wizardCreate from './Create';

const wizardIndex = {
  wizardCreate
};

export default wizardIndex;